import { DateOfBirthDateOfDeath } from '../../Components/DateOfBirthDateOfDeath';
import { LiveBadge } from '../../Components/LiveBadge';
import { FuneralServiceSummaryDetails, Organization } from '../../types';
import VerticalListServiceEvents from '../VerticalListServiceEvents';

const TiledService = ({
  service,
  organization,
  scrollElementRef,
}: {
  service: FuneralServiceSummaryDetails;
  organization: Organization | undefined;
  scrollElementRef: any;
}) => {
  const isAssociation = organization?.type === 'association';

  const baseUrl = isAssociation ? service?.organization?.embed_url : organization?.embed_url;
  const serviceUrl = baseUrl ? baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'funeral=' + service?.hash : undefined;

  return (
    <div className="card-list-service-style" ref={scrollElementRef}>
      <a href={serviceUrl} target={isAssociation ? '_blank' : undefined} className="absolute inset-0 bottom-0 left-0 right-0 top-0 z-20"></a>
      {service?.events?.reduce((a, b) => a || b?.stream?.stream_status?.value === 'started', false) ? <LiveBadge href={serviceUrl} /> : null}
      {service.profile_photo_url ? (
        <img className="card-list-service-image" src={service.profile_photo_url} alt={service.name} />
      ) : (
        <div className="no-image-list-vertical" />
      )}
      <div className="card-list-service-details">
        <div>
          <h2 className="card-list-service-name">
            {service.listingName.map((formatted) =>
              formatted?.key ? (
                <span key={formatted?.key} className={'list-title-' + formatted?.key}>
                  {formatted?.text}
                </span>
              ) : null,
            )}
          </h2>
        </div>
        <DateOfBirthDateOfDeath dateOfBirth={service.date_of_birth} dateOfDeath={service.date_of_death} format={organization?.date_format} />
        <VerticalListServiceEvents events={service.events} organization={organization} />
      </div>
    </div>
  );
};

export default TiledService;
